import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const HEADER_HEIGHT = 55;
export const FOOTER_HEIGHT = 62;

export const styles = StyleSheet.create((colors) => ({
  container: {
    rowGap: theme.spacing[6],
    backgroundColor: colors.backgroundL1Inverse,
    borderRadius: theme.borderRadius.s,
    maxHeight: 600 + HEADER_HEIGHT + FOOTER_HEIGHT + theme.spacing[6] * 2,
    width: {
      base: undefined,
      tablet: 456,
    },
    maxWidth: {
      base: undefined,
      tablet: 456,
    },

    variants: {
      position: {
        absolute: {
          position: 'absolute',
          bottom: {
            base: theme.spacing[2],
            desktop: theme.spacing[6],
          },
          left: {
            base: theme.spacing[2],
            desktop: theme.spacing[6],
          },
          right: {
            base: theme.spacing[2],
            desktop: undefined,
          },
        },
        relative: {
          position: 'relative',
        },
      },
    },
  },
  tabsHeader: {
    alignItems: 'center',
    height: HEADER_HEIGHT,
    paddingHorizontal: theme.spacing[6],
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderColor: 'rgb(58, 58, 60)',
  },
  tabButton: {
    flex: 1,
    height: HEADER_HEIGHT,
    alignItems: 'center',
    justifyContent: 'center',
  },
  tabButtonSelected: {
    borderBottomWidth: 1,
    borderColor: colors.borderBrand,
  },
  button: {
    flex: 1,
    height: 40,
    borderColor: colors.backgroundPrimary,
  },
  footer: {
    flex: 1,
    height: FOOTER_HEIGHT,
    paddingBottom: theme.spacing[6],
  },
  underlineText: {
    textDecorationLine: 'underline',
  },
  resizableContainer: {
    maxHeight: 600,
  },
  buttonsContainer: {
    flexDirection: 'row',
    gap: theme.spacing[2],
  },
}));
